/* eslint no-param-reassign: 0 */
import types from '../mutation-types';
import WgptOnboardingAPI from 'dashboard/api/wgpt/onboarding';

const state = {
  isPending: false,
  brand: null,
  accountId: null,
  uiFlags: {
    isFetching: false,
    isCompleting: false,
  },
};

export const getters = {
  getUIFlags($state) {
    return $state.uiFlags;
  },
  isPending($state) {
    return $state.isPending;
  },
  getBrand($state) {
    return $state.brand;
  },
  accountId($state) {
    return $state.accountId;
  },
};

export const actions = {
  get: async ({ commit }, accountId) => {
    if (!accountId) return;
    commit(types.SET_WGPT_ONBOARDING_UI_FLAG, { isFetching: true });
    try {
      const { data } = await WgptOnboardingAPI.get(accountId);
      commit(types.SET_WGPT_ONBOARDING, { ...data, accountId });
    } catch {
      commit(types.SET_WGPT_ONBOARDING, {
        pending: false,
        platform: null,
        accountId,
      });
    } finally {
      commit(types.SET_WGPT_ONBOARDING_UI_FLAG, { isFetching: false });
    }
  },
  complete: async ({ commit }) => {
    commit(types.SET_WGPT_ONBOARDING_UI_FLAG, { isCompleting: true });
    try {
      await WgptOnboardingAPI.delete();
      commit(types.SET_WGPT_ONBOARDING, { pending: false });
    } finally {
      commit(types.SET_WGPT_ONBOARDING_UI_FLAG, { isCompleting: false });
    }
  },
};

export const mutations = {
  [types.SET_WGPT_ONBOARDING_UI_FLAG]($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
  [types.SET_WGPT_ONBOARDING]($state, data) {
    $state.isPending = data.pending ?? false;
    $state.brand = data.brand ?? null;
    $state.accountId = data.accountId ?? null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
